import { motion } from "framer-motion";

/**
 * Slow editorial marquee. Duplicates content twice for seamless loop.
 * `reverse` flips direction. `slow` gives a very editorial pace.
 */
export default function Marquee({ items = [], reverse = false, duration = 40, className = "" }) {
    return (
        <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
            {/* Edge fade */}
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-background to-transparent z-10" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-background to-transparent z-10" />

            <motion.div
                className="flex whitespace-nowrap"
                animate={{ x: reverse ? ["-50%", "0%"] : ["0%", "-50%"] }}
                transition={{ duration, repeat: Infinity, ease: "linear" }}
            >
                {[...items, ...items].map((it, i) => (
                    <span
                        key={i}
                        className="flex items-center gap-6 px-6 shrink-0"
                    >
                        <span className="font-display text-4xl md:text-6xl lg:text-7xl tracking-tight text-foreground/85">
                            {it}
                        </span>
                        <span className="h-2 w-2 rounded-full bg-gold shrink-0" />
                    </span>
                ))}
            </motion.div>
        </div>
    );
}
